"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconDistances = function IconDistances(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.88624 17.7845C9.02218 17.6483 9.09852 17.4638 9.09852 17.2715C9.09852 17.0791 9.02218 16.8946 8.88624 16.7585L7.84824 15.7265L17.99 15.7265C18.0345 15.735 18.08 15.7393 18.126 15.7393H22.212L21.198 16.7713C21.0621 16.9074 20.9857 17.0919 20.9857 17.2843C20.9857 17.4767 21.0621 17.6612 21.198 17.7973C21.2635 17.8657 21.3422 17.9202 21.4294 17.9574C21.5165 17.9946 21.6103 18.0138 21.705 18.0138C21.7998 18.0138 21.8935 17.9946 21.9807 17.9574C22.0678 17.9202 22.1465 17.8657 22.212 17.7973L24.45 15.5293C24.5849 15.3914 24.6604 15.2062 24.6604 15.0133C24.6604 14.8204 24.5849 14.6352 24.45 14.4973L22.212 12.2293C22.1462 12.1571 22.0661 12.0994 21.9767 12.0599C21.8873 12.0204 21.7907 12 21.693 12C21.5953 12 21.4987 12.0204 21.4093 12.0599C21.3199 12.0994 21.2398 12.1571 21.174 12.2293C21.0381 12.3654 20.9617 12.5499 20.9617 12.7423C20.9617 12.9347 21.0381 13.1192 21.174 13.2553L22.212 14.2873H19.7999V14.2745H7.84824L8.86225 13.2425C8.99818 13.1063 9.07452 12.9218 9.07452 12.7295C9.07452 12.5371 8.99818 12.3526 8.86225 12.2165C8.79672 12.148 8.71801 12.0936 8.63088 12.0564C8.54375 12.0192 8.44999 12 8.35524 12C8.2605 12 8.16674 12.0192 8.07961 12.0564C7.99248 12.0936 7.91377 12.148 7.84824 12.2165L5.61025 14.4845C5.47538 14.6224 5.39987 14.8076 5.39987 15.0005C5.39987 15.1933 5.47538 15.3786 5.61025 15.5165L7.84824 17.7845C7.91403 17.8567 7.99418 17.9144 8.08355 17.9539C8.17291 17.9934 8.26954 18.0138 8.36724 18.0138C8.46495 18.0138 8.56157 17.9934 8.65094 17.9539C8.74031 17.9144 8.82046 17.8567 8.88624 17.7845Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1 11.3999C26.5971 11.3999 27 11.8028 27 12.2999L27 18.2999C27 18.797 26.5971 19.1999 26.1 19.1999C25.6029 19.1999 25.2 18.797 25.2 18.2999L25.2 12.2999C25.2 11.8028 25.6029 11.3999 26.1 11.3999Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.89999 11.3999C4.39704 11.3999 4.79999 11.8028 4.79999 12.2999L4.79999 18.2999C4.79999 18.797 4.39704 19.1999 3.89999 19.1999C3.40293 19.1999 2.99999 18.797 2.99999 18.2999L2.99999 12.2999C2.99999 11.8028 3.40293 11.3999 3.89999 11.3999Z",
    fill: color
  }));
};

IconDistances.defaultProps = {
  color: 'black'
};
IconDistances.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconDistances;
exports.default = _default;